import React from 'react';
import { Box, Flex, Avatar, Text, CircularProgress, CircularProgressLabel, Card } from '@chakra-ui/react';
import { FaUserCircle } from 'react-icons/fa';
import backgroundImage from '../../assets/postjob.jpg'; // Import your background image
// Import your background image

const ProfileStatus = () => {
  return (
    <Box
      width="100%"
      height="100%"
      bgImage={`url(${backgroundImage})`} // Set the background image
      bgSize="cover"
      bgPosition="center"
      position="relative"
    >
      <Card
        bg="gray.100"
        shadow="md"
        borderRadius="md"
        width="250px" // Adjusted width for more space
        p={3} // Smaller padding
        position="absolute"
        bottom={4}
        left={4}
      >
        <Flex
          direction="row"
          align="center"
          justify="flex-start"
          textAlign="left"
        >
          <Box position="relative" mr={3}>
            <CircularProgress value={75} color="green.400" size="60px" thickness="6px">
              <CircularProgressLabel fontSize="xs">75%</CircularProgressLabel>
            </CircularProgress>
            <Avatar
              size="sm"
              icon={<FaUserCircle />}
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
            />
          </Box>
          <Box>
            <Text fontWeight="bold" mb={1} fontSize="sm">John Doe</Text>
            <Text mt={2} fontSize="xs" color="gray.600">Your profile is 75% complete</Text>
          </Box>
        </Flex>
      </Card>
    </Box>
  );
};

export default ProfileStatus;